import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface HotLane {
  origin: string;
  destination: string;
  loadCount: number;
}

export interface TrendItem {
  label: string;
  count: number;
}

export interface MarketplaceTrends {
  topEquipmentTypes: TrendItem[];
  topCargoTypes: TrendItem[];
  averageWeight: number;
  averagePallets: number;
}

export interface LaneIntelligence {
  averageRate: number;
  rpm: number;
  winRangeMin: number;
  winRangeMax: number;
  carrierInterest: string;
  deadheadRisk: string;
  topCarrierCount: number;
  paymentPreference: string;
  accessorialNorms: string;
  sampleSize: number;
}

@Injectable({ providedIn: 'root' })
export class MarketplaceAnalyticsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.aiServiceApiUrl}marketplace/analytics`;

  getHotLanes(limit = 5, shipperCompanyId?: number, lang?: string): Observable<HotLane[]> {
    let params = new HttpParams().set('limit', limit.toString());
    if (shipperCompanyId) {
      params = params.set('shipperCompanyId', shipperCompanyId.toString());
    }
    if (lang) {
      params = params.set('lang', lang);
    }

    return this.http.get<HotLane[]>(`${this.baseUrl}/hot-lanes`, {
      params
    });
  }

  getTrends(limit = 5, shipperCompanyId?: number, lang?: string): Observable<MarketplaceTrends> {
    let params = new HttpParams().set('limit', limit.toString());
    if (shipperCompanyId) {
      params = params.set('shipperCompanyId', shipperCompanyId.toString());
    }
    if (lang) {
      params = params.set('lang', lang);
    }

    return this.http.get<MarketplaceTrends>(`${this.baseUrl}/trends`, {
      params
    });
  }

  getLaneIntelligence(origin: string, destination: string): Observable<LaneIntelligence> {
    return this.http.get<LaneIntelligence>(`${this.baseUrl}/lane-intelligence`, {
      params: { origin, destination }
    });
  }
}
